module.exports = __webpack_public_path__ + "img/part4-label.f6873ff2.png";